import { put, takeEvery } from 'redux-saga/effects'
import { PRODUCTS_BY_TYPE_LOADING, PRODUCTS_DATA_SUCCESS, PRODUCTS_DATA_ERROR } from "../actions/actionProduct";
import { apiGetProductsByProductTypeAndDisplayArea } from 'api';

async function fetchAsync(func, param1, param2) {
    const response = await func(param1, param2);

    if (response.ok && response.status == 200) {
        return await response.json();
    }
    else if (response.status == 204) {
        return "nocontent";
    }
    else if (response.status == 400) {
        throw await response.json();
    }
    else {
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to get products, response status: " + response.status + "\"}]}")
    }
}

function* fetchProductDataByType(action) {
    try {
        const data = yield fetchAsync(apiGetProductsByProductTypeAndDisplayArea, action.productType, action.displayAreaNo)
        yield put({ type: PRODUCTS_DATA_SUCCESS, payload: data });
    } catch (e) {
        yield put({ type: PRODUCTS_DATA_ERROR, error: e.message });
    }
}

export const sagaProduct = [
    takeEvery(PRODUCTS_BY_TYPE_LOADING, fetchProductDataByType)
];
